/*
 *  Author: DL
 *  Date: 2020-12-04 14:54:29
 *  Email: dunaliang@fengmap.com
 *  LastEditTime: 2020-12-17 14:27:07
 *  LastEditors: DL
 *  Description: 实时定位控件
 *  Copyright: Copyright 2014 - 2020, FengMap, Ltd. All rights reserved.
 */

import React, { useContext, useState, useCallback, useEffect, useLayoutEffect } from 'react';
import { Button, Icon, Alert } from 'ui';
import Context from '@/hook/useFmapContext';
import Control from '@/components/Control';
import { isEmpty } from 'utils/tools';

export default props => {
    const { fmap, current } = useContext(Context);

    const [active, setAcitve] = useState(false);
    const [visible, setVisible] = useState(false);

    const handleLocationClick = useCallback(
        event => {
            event.stopPropagation();
            if (isEmpty(current)) {
                setVisible(true);
            } else {
                setAcitve(!active);
            }
        },
        [active, current],
    );

    const handleTouch = useCallback(event => {
        setAcitve(false);
    }, []);

    useEffect(() => {
        if (active) {
            if (isEmpty(current)) {
                setAcitve(false);
            } else {
                const { x, y, groupID } = current;

                if (fmap.map.viewMode !== 'top') {
                    fmap.map.viewMode = 'top';
                }

                fmap.map.moveTo({
                    x,
                    y,
                    groupID,
                    callback: () => {
                        fmap.map.scaleLevelTo({
                            duration: 1,
                            level: 23,
                        });
                    },
                });
            }
        }
    }, [fmap, current, active]);

    useLayoutEffect(() => {
        if (window.device.mobile()) {
            document.querySelector('#root').addEventListener('touchstart', handleTouch);
            document.querySelector('#locationBtn').addEventListener('touchstart', handleLocationClick);
        } else {
            document.querySelector('#root').addEventListener('click', handleTouch);
            document.querySelector('#locationBtn').addEventListener('click', handleLocationClick);
        }

        return () => {
            if (window.device.mobile()) {
                document.querySelector('#root').removeEventListener('touchstart', handleTouch);
                document.querySelector('#locationBtn').removeEventListener('touchstart', handleLocationClick);
            } else {
                document.querySelector('#root').removeEventListener('click', handleTouch);
                document.querySelector('#locationBtn').removeEventListener('click', handleLocationClick);
            }
        };
    }, [handleTouch, handleLocationClick]);

    return (
        <>
            <Alert message="当前没有我的位置" visible={visible} onClose={() => setVisible(false)} />
            <Control>
                <Button id="locationBtn" type={active ? 'primary' : ''}>
                    <Icon className={'icondw'} />
                </Button>
            </Control>
        </>
    );
};
